import React from "react";
import Topbar from "./Topbar";

interface PropsType {
  children: React.ReactNode;
}

const Layout = (props: PropsType) => {
  const { children } = props;

  return (
    <>
      <Topbar />
      <main>{children}</main>
    </>
  );
};

export default Layout;
